module.exports = __webpack_public_path__ + "media/images/submission-term-background-97223598.gif";